import styled from "styled-components";

export const Wrapper = styled.div`
    position: fixed;
    right: 40px;
    top: 30px;
    z-index: 100;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: white;

    padding-top: 3px;
    outline: none;
    border: none;
`;

export const Language = styled.div`
    font-size: 20px;
    cursor: pointer;
    font-weight: ${props => (props.selected ? "bold" : "lighter")};
    line-height: 16.7px;
`;

export const VerticalLine = styled.div`
    height: 20px;
    border-left: 1px solid black;
    margin: 0 7px;
`;
